import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import {GatsbyImage} from 'gatsby-plugin-image'
import './ImgRow.scss'
import joinClassNames from '../../helpers/joinClassNames'
import PageComponent from './PageComponent'
import cmsMarkdownRenderers from '../../helpers/markdown/cmsMarkdownRenderers'

const ImgRow = ({imageData, content, imageAlt, imagePosition, imageSize, backgroundColor}) => {
    const imageSizeStyle = imageSize ? {'--image-size': `${imageSize}%`} : {}
    const contentStyle = imageSize ? {'--content-size': `${100 - imageSize}%`} : {}

    return (
        <PageComponent backgroundColor={backgroundColor}>
            <div
                className={joinClassNames(
                    'page__img-row',
                    imagePosition ? `page__img-row--${imagePosition}` : null,
                    content ? null : `page__img-row-no-content`
                )}
            >
                {content && (
                    <section className="page__img-row__content" style={contentStyle}>
                        <ReactMarkdown source={content} escapeHtml={false} renderers={cmsMarkdownRenderers} />
                    </section>
                )}
                {imageData && (
                    <GatsbyImage
                        image={imageData}
                        alt={imageAlt}
                        className={'page__img-row__image'}
                        style={imageSizeStyle}
                    />
                )}
            </div>
        </PageComponent>
    )
}

ImgRow.propTypes = {
    id: PropTypes.string,
    content: PropTypes.string,
    imageData: PropTypes.object,
    imageAlt: PropTypes.string,
    imagePosition: PropTypes.string,
    imageSize: PropTypes.number,
    backgroundColor: PropTypes.string,
}

ImgRow.defaultProps = {
    content: '',
    imageAlt: '',
    imagePosition: 'bottom',
    imageSize: 50,
    backgroundColor: 'white',
}

export default ImgRow
